/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'components/success': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" _fill="#14803A" fill-rule="evenodd" d="M24 3C12.402 3 3 12.402 3 24s9.402 21 21 21 21-9.402 21-21S35.598 3 24 3zM1 24C1 11.297 11.297 1 24 1s23 10.297 23 23-10.297 23-23 23S1 36.703 1 24zm36.414-8L20 33.414 10.586 24 12 22.586l8 8 16-16L37.414 16z" clip-rule="evenodd"/>'
  }
})
